import mixitup from 'mixitup';

export default class NewsFilter {
    constructor($newsfilter) {
        this.newsCards = $newsfilter.querySelector('[data-news-cards]');
        this.newsButtons = $newsfilter.querySelector('[data-news-buttons]');
        this.filterControls = this.newsButtons.querySelectorAll('[data-filter]');

        this.mixer = mixitup(this.newsCards, {
            selectors: {
                control: '[data-filter]'
            },
            callbacks: {
                onMixEnd: state => {
                    this.filterNewsCards(state.activeFilter.selector);
                }
            }
        });

        this.filterControls.forEach(control => {
            control.addEventListener('click', () => {
                this.filterControls.forEach(c => c.classList.remove('active'));
                control.classList.add('active');

                if (control.dataset.filter === 'all') {
                    this.showAllNewsCards();
                }
            });
        });
    }

    filterNewsCards(selector) {
        const newsCards = this.newsCards.querySelectorAll('.c-newscard');

        newsCards.forEach(card => {
            if (!card.matches(selector)) {
                card.style.display = 'none';
            } else {
                card.style.display = '';
            }
        });
    }

    showAllNewsCards() {
        const newsCards = this.newsCards.querySelectorAll('.c-newscard');

        newsCards.forEach(card => {
            card.style.display = '';
        });
    }
}
